import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.7808 12.8125H4.23053C4.0856 12.8127 3.9446 12.7633 3.82837 12.6718C3.71213 12.5801 3.62693 12.451 3.58549 12.3039L1.53494 6.101C1.49143 5.96362 1.48848 5.81535 1.5265 5.67614C1.56452 5.53692 1.64169 5.41328 1.7477 5.32179C1.85372 5.23031 1.98355 5.17525 2.11985 5.16406C2.25615 5.15276 2.39243 5.18594 2.5105 5.25901L5.3324 7.49578L7.98764 3.44964C8.01106 3.41504 8.03908 3.38431 8.07095 3.35846C8.19189 3.24876 8.34575 3.18811 8.50498 3.1875H8.55604C8.64396 3.19483 8.72977 3.22057 8.80838 3.26311C8.88699 3.30565 8.95696 3.36416 9.01426 3.4354L11.6802 7.48153L14.5276 5.25901C14.6436 5.2011 14.7728 5.17953 14.9 5.19693C15.027 5.21443 15.1469 5.27 15.2452 5.35731C15.3477 5.4434 15.4244 5.55931 15.4657 5.69089C15.5069 5.82257 15.5111 5.96403 15.4777 6.09815L13.4244 12.3053C13.3828 12.452 13.2977 12.5805 13.1818 12.6719C13.0658 12.7632 12.9252 12.8125 12.7808 12.8125Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgCrown);
export default ForwardRef;
